export const categories = [
  { id: "esotericism", label: "Esotericism", x: 50, y: 8 },
  { id: "cybernetics", label: "Cybernetics", x: 84, y: 24 },
  { id: "politics", label: "Politics", x: 92, y: 58 },
  { id: "medieval", label: "Medieval History", x: 70, y: 86 },
  { id: "literature", label: "Literature", x: 30, y: 86 },
  { id: "music", label: "Music", x: 8, y: 58 },
  { id: "projects", label: "Projects", x: 16, y: 24 },
];

export const intersections = [
  {
    id: "cybernetics-literature",
    title: "Cyberfiction",
    excerpt: "",
    x: 57,
    y: 55,
  },
  {
    id: "esotericism-medieval-history",
    title: "Hermetic Medievalism",
    excerpt: "",
    x: 60,
    y: 47,
  },
  {
    id: "politics-technology",
    title: "Technopolitics",
    excerpt: "",
    x: 88,
    y: 42,
  },
  {
    id: "music-literature",
    title: "Lyricism",
    excerpt: "",
    x: 19,
    y: 72,
  },
  {
    id: "projects-esotericism",
    title: "Ritual Engineering",
    excerpt: "",
    x: 31,
    y: 17,
  },
  {
    id: "politics-medieval-history",
    title: "Historical Power",
    excerpt: "",
    x: 81,
    y: 72,
  },
];